import React, {createContext, useContext} from 'react';

/**
 * Turns of validation. Used in Compare mode as we dont have to validate original values.
 * No reason to show readonly values with validation errors.
 */
export const DataFormValidationContext = createContext<boolean>(true);

export const DataFormNoValidation: React.FC<{children: React.ReactNode}> = ({
  children,
}) => (
  <DataFormValidationContext.Provider value={false}>
    {children}
  </DataFormValidationContext.Provider>
);

export const useDataFormValidationContext = (): boolean =>
  useContext(DataFormValidationContext);
